import React, { useCallback, useEffect } from "react";

import { ClockIcon } from "@repo/design-system/icons";

import { IShopProduct } from "@core/models/Product/product.types.ts";
import { useEventTracker } from "@core/providers/EventTrackerProvider.tsx";
import { ProductEvents, SourceTypesEnum } from "@core/services";
import ProductList from "@flow/Shop/components/Products/ProductList.tsx";

interface IRelatedProductsProps {
  data: {
    products: IShopProduct[];
    title: string;
    subtitle: string;
    count: number;
  };
}

export const RelatedProducts: React.FC<IRelatedProductsProps> = ({
  data: { products, count, title, subtitle },
}) => {
  const { trackEvent } = useEventTracker();

  useEffect(() => {
    if (products && products.length) {
      trackEvent({
        eventName: ProductEvents.RELATED_CATEGORY_BLOCK_LOADED,
        data: {
          source: SourceTypesEnum.Shop,
        },
      });
    }
  }, [products]);

  const onProductCardClick = useCallback((productId?: number) => {
    trackEvent({
      eventName: ProductEvents.RELATED_CATEGORY_BLOCK_CLICKED,
      data: {
        source: SourceTypesEnum.Shop,
        product_id: productId,
      },
    });
  }, []);

  if (products && products.length) {
    return (
      <div className="mb-4">
        <div className="my-4 md:my-6 bg-backgroundSecondary rounded-xl p-4 md:p-6 flex items-center justify-between gap-4">
          <div className="flex items-center gap-4 flex-1 min-w-0">
            <div className="w-10 h-10 rounded-[10px] bg-backgroundTertiary flex items-center justify-center shrink-0">
              <ClockIcon
                className="text-contentPrimary"
                width={20}
                height={20}
              />
            </div>
            <div>
              <h3 className="text-base font-medium text-contentPrimary leading-normal">
                {title}
              </h3>
              <p className="text-sm text-contentTertiary leading-snug mt-0.5">
                {subtitle}
              </p>
            </div>
          </div>
          <span className="text-sm text-contentTertiary whitespace-nowrap shrink-0">
            {count}
          </span>
        </div>
        <div className="mb-4">
          <ProductList onCardClick={onProductCardClick} products={products} />
        </div>
      </div>
    );
  }
  return <></>;
};
